// BuildingStabilityInfoComponent.js
import { useState } from 'react';
import ModalUploadFileLog from 'shared/components/uploadFileModal/uploadFileModal';
import { FileLabel } from 'shared/types/file';

// Assuming BuildingStabilityInfoDTO is defined elsewhere in your application
import { BuildingDTO } from 'shared/types/building';
import { UnitDTO } from 'shared/types/unit';
import { BuildingPlansInfo } from 'shared/types/building-plans-info';
import FileLogTable from 'shared/components/uploadFileModal/fileLogTable';

interface BuildingPlansInfoComponentProps {
    buildingPlansInfo: BuildingPlansInfo;
    handleInspectionInfoChangeInParent?: (value: any) => any;
    handleSaveInParent?: () => any;
    handleCloseParent?: () => any;
    building: BuildingDTO,
    unit: UnitDTO,
    parentEditMode?: boolean;
}


const BuildingPlansInfoComponent = ({
    buildingPlansInfo,
    building,
    unit,
}: BuildingPlansInfoComponentProps) => {
    const [editedBuildingPlansInfo, setEditedBuildingPlansInfo] = useState(buildingPlansInfo);
    const [fileModalOpen, setFileModalOpen] = useState<boolean>(false);

    const handleOpenAddPlansDocumentModal = () => {
        setFileModalOpen(true);
    };

    const handleFileModalClose = () => {
        setFileModalOpen(false);
    };

    const handleFileModalSave = async (fileLogData: any) => {
        const newBuildingPlanFileLogs = fileLogData.customData?.savedBuildingPlansInfo.buildingPlanFileLogs;
        if (newBuildingPlanFileLogs) {
            setEditedBuildingPlansInfo((prev) => ({ ...prev, buildingPlanFileLogs: newBuildingPlanFileLogs }));
        }
        handleFileModalClose();
    };

    // Placeholder for getFileSection similar to CadastreInfoComponent

    return (
        <section className="flex flex-col gap-0 rounded-md bg-white">
            <div className="p-3">
                <div className="gap-3 sm:grid sm:grid-cols-2">
                    {/* File upload logic */}
                    <div className="col-span-full mt-8 flex flex-col gap-3">
                        <FileLogTable
                            acceptedLabels={[FileLabel.PlanGeneriek, FileLabel.PlanVoorstelNieuweToestand, FileLabel.PlanCommercieel, FileLabel.PlanKadaster, FileLabel.PlanLandmeter, FileLabel.PlanUitvoering, FileLabel.PlanVergunning, FileLabel.PlanVoorontwerp, "Plan Riolering"]}
                            onUploadClick={handleOpenAddPlansDocumentModal} 
                            building={building}
                            />  
                    </div>
                    {/* Modal for File Upload */}
                    <ModalUploadFileLog
                        isOpen={fileModalOpen}
                        onClose={() => setFileModalOpen(false)}
                        onSave={(fileLogData) => handleFileModalSave(fileLogData)}
                        building={building}
                        unit={unit}
                        incomingCustomData={{ buildingPlansInfoId: editedBuildingPlansInfo?.id }}
                        customLabels={[FileLabel.PlanGeneriek, FileLabel.PlanVoorstelNieuweToestand, FileLabel.PlanCommercieel, FileLabel.PlanKadaster, FileLabel.PlanLandmeter, FileLabel.PlanUitvoering, FileLabel.PlanVergunning, FileLabel.PlanVoorontwerp, "Plan Riolering"]}
                    />
                </div>
            </div>
        </section>
    );
};

export default BuildingPlansInfoComponent;
